import React, { useState } from "react";
import {
  TbMail,
  TbMapPinPin,
  TbPencil,
  TbPhone,
  TbUserEdit,
} from "react-icons/tb";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Col,
  Dialog,
  FabButton,
  Flex,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../../ppui";
import { Icon } from "../../../../ppui/icon";
import {
  CardViewBox,
  CardViewBoxBorder,
  ContentBody,
  ContentHeading,
  ContentLayout,
  PhotoUpload,
  ViewLightBG,
} from "../../../../pages/style";
import { useNavigate } from "react-router-dom";
import useOrganizationLists from "./organization-list.service";
import { logger } from "../../../../utils/logger";
import { getOrganizationCategoryNameById } from "./organization-list-constant";

const AdminOrganizationList = ({ openSnackbar }) => {
  const [organizationEdit, setOrganizationEdit] = React.useState(false);
  const [selectedOrganization, setSelectedOrganization] = React.useState(null);
  const route = useNavigate();
  const { organizations, refetch, statusUpdate, pagination } = useOrganizationLists();
  const [btnLoading, setBtnLoading] = useState(false);

  const AttendanceInfoModalOpen = (organization) => {
    setSelectedOrganization(organization);
    setOrganizationEdit(true);
  };

  const OrganizationEditModalClose = () => {
    setSelectedOrganization(null);
    setOrganizationEdit(false);
  };

  const handleStatusChange = (orgId, event) => {
    const newStatus = event;
    setSelectedOrganization((prev) => ({
      ...prev,
      status: newStatus,
    }));
  };

  const handleSubmitStatus = (orgId, orgInfo) => {
    setBtnLoading(true);
    statusUpdate(orgId, orgInfo.status)
      .then((message) => {
        openSnackbar({ message });
        refetch();
        OrganizationEditModalClose();
      })
      .catch((error) => {
        logger.error("Error updating status:", error);
        openSnackbar({ message: "Error updating status:", color: "danger" });
      }).finally(()=>{
        setBtnLoading(false);
      });
  };

  const handlePagination = (direction) => {
    const nextPage = direction === "next" ? pagination.page + 1 : pagination.page - 1;
    if (nextPage > 0 && nextPage <= pagination.totalPages) {
      refetch(nextPage, pagination.pageSize);
    }
  };

  

  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Organization
          </Typography>

          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              route("/admin/add-organization");
            }}
          >
            Add Organization
          </Button>
        </ContentHeading>

        <ContentBody Padding>
          <Row rowGap>
            {organizations && organizations.length > 0 ? (
              organizations.map((organization) => (
                <Col key={organization.id} sm={12} md={6} lg={4} xl={4} xxl={4}>
                  <CardViewBox>
                    <Row alignItem="center" mb={15}>
                      <Col sm={12} md={"auto"}>
                        <Avatar
                          initials={organization.name?.[0]}
                          color={"primary"}
                        />
                      </Col>

                      <Col>
                        <Flex justifyContent="space-between">
                          <Flex direction="column" alignItem="start">
                            <Typography
                              variant="body1"
                              strong
                              mb={"5"}
                              color="primary"
                            >
                              {organization.org_name || "Unknowwn "}
                            </Typography>
                            <Typography variant="body2" mb={"0"}>
                              {getOrganizationCategoryNameById(
                                organization.registration_type
                              ) || "Industry not specified"}
                            </Typography>
                          </Flex>
                          <Flex
                            justifyContent="space-between"
                            direction="column"
                            alignItem="end"
                            gap={10}
                          >
                            <FabButton
                              icon={<TbPencil />}
                              shape="rounded"
                              size="sm"
                              variant="filled"
                              onClick={() =>
                                route(`/admin/organization/${organization.org_id}`)
                              }
                            />

                            {organization.status === "approved" && (
                              <Chip
                                onClick={() =>
                                  AttendanceInfoModalOpen(organization)
                                }
                                color="success"
                                dot
                                label="Approved"
                                size="sm"
                              />
                            )}
                            {organization.status === "rejected" && (
                              <Chip
                                onClick={() =>
                                  AttendanceInfoModalOpen(organization)
                                }
                                color="danger"
                                dot
                                label="Rejected"
                                size="sm"
                              />
                            )}
                            {organization.status === "pending" && (
                              <Chip
                                onClick={() =>
                                  AttendanceInfoModalOpen(organization)
                                }
                                color="warning"
                                dot
                                label="Pending"
                                size="sm"
                              />
                            )}
                          </Flex>
                        </Flex>
                      </Col>
                    </Row>
                    <CardViewBoxBorder />
                    <Flex alignItem="center" gap={"5"}>
                      <Icon size={"sm"}>
                        <TbPhone />
                      </Icon>
                      <Typography variant="body2" mb={"0"}>
                        {organization.phone || "No phone available"}
                      </Typography>
                    </Flex>
                    <Flex alignItem="center" gap={"5"}>
                      <Icon size={"sm"}>
                        <TbMail />
                      </Icon>
                      <Typography variant="body2" mb={"0"}>
                        {organization.email || "No email available"}
                      </Typography>
                    </Flex>
                    <CardViewBoxBorder />
                    <ViewLightBG>
                      <Flex alignItem="center" py={10} px={15} gap={10}>
                        <Icon size={"sm"}>
                          <TbMapPinPin />
                        </Icon>
                        <Typography variant="body2" mb={"0"}>
                          {[
                            organization.address,
                            organization.city,
                            organization?.indian_states?.state_name,
                            organization.country,
                            organization.pincode,
                            organization.locality,
                          ]
                            .filter(Boolean)
                            .join(", ") || "No address available"}
                        </Typography>
                      </Flex>
                    </ViewLightBG>
                  </CardViewBox>
                </Col>
              ))
            ) : (
              <Typography>No organizations found.</Typography>
            )}
          </Row>

          {/* Pagination */}
          <Box mt={20}>
            <Flex alignItem="center" justifyContent="center" gap={10}>
              <Button color="default"
                colorvariant="main"
                variant="outlined"
                size="sm"
                disabled={pagination.page === 1}
                onClick={() => handlePagination("previous")}
                >
                Previous
              </Button>
              <Typography
                variant="body2"
                mb="0"
                color="dark"
                colorvariant="light"
              >
                Page {pagination.page} of {pagination.totalPages}
              </Typography>
              <Button color="default"
                colorvariant="main"
                variant="outlined"
                size="sm"
                disabled={pagination.page === pagination.totalPages}
                onClick={() => handlePagination("next")}
                >
                Next
              </Button>
            </Flex>
          </Box>
          {/* Pagination */}
        </ContentBody>
      </ContentLayout>

      {/* Organization-Edit */}
      <Dialog
        title="Edit Organization"
        closeButton={true}
        fullWidth
        maxWidth="md"
        open={organizationEdit}
        onClose={OrganizationEditModalClose}
        btnLoading={btnLoading}
        onSubmit={() =>
          handleSubmitStatus(selectedOrganization.org_id, selectedOrganization)
        }
      >
        {selectedOrganization && (
          <Row>
            <Col sm={12} md={"auto"}>
              <PhotoUpload>
                <TbUserEdit />
              </PhotoUpload>
            </Col>
            <Col col-xs={"auto"}>
              <Row rowGap>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    fullWidth
                    label="Organization Name"
                    placeholder="Type Here"
                    value={selectedOrganization.org_name || ""}
                    valueSinc
                  />
                </Col>
                {/* <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    fullWidth
                    label="Organization Category"
                    type="text"
                    placeholder="Type Here"
                    valueSinc 
                    value={selectedOrganization.industry || ""}
                  />
                </Col> */}
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    fullWidth
                    label="Phone"
                    type="tel"
                    placeholder="Type Here"
                    valueSinc
                    value={selectedOrganization.phone || ""}
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    fullWidth
                    label="Email"
                    type="email"
                    placeholder="Type Here"
                    valueSinc
                    value={selectedOrganization.email || ""}
                  />
                </Col>

                {/* <Col sm={12} md={6} lg={6} xxl={4}>
                  <InputField
                    fullWidth
                    label="Address"
                    type="text"
                    placeholder="Type Here"
                    value={
                      [
                        selectedOrganization.address,
                        selectedOrganization.city,
                        selectedOrganization.state,
                        selectedOrganization.country,
                        selectedOrganization.pincode,
                        selectedOrganization.locality,
                      ]
                        .filter(Boolean)
                        .join(", ") || "No address available"
                    }
                  />
                </Col> */}

                <Col sm={12} md={6} lg={6} xxl={4}>
                  <SelectField
                    fullWidth
                    label="Status"
                    options={[
                      { id: "approved", name: "Approve" },
                      { id: "pending", name: "Pending", disabled: true },
                      { id: "rejected", name: "Reject" },
                    ]}
                    defaultValue={selectedOrganization.status || "Pending"}
                    placeholder="Select Here..."
                    onChange={(event) =>
                      handleStatusChange(selectedOrganization.org_id, event)
                    }
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </Dialog>
      {/* Organization-Edit */}
    </>
  );
};

export default AdminOrganizationList;
